import React from 'react';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import type { GroupShare } from '@atlassian/jira-shared-types/src/share-permission.tsx';
import { NameWrapper, IconWrapper } from '../common/styled.tsx';

type Props = {
	sharePermission: GroupShare;
};

export default function GroupName({ sharePermission: { group } }: Props): React.JSX.Element {
	return (
		<>
			<IconWrapper>
				<PeopleGroupIcon label="" spacing="spacious" />
			</IconWrapper>
			<NameWrapper>{group.name}</NameWrapper>
		</>
	);
}
